import { render, staticRenderFns } from "./ERegistrationPublicTermCondView.vue?vue&type=template&id=57ba74f2&scoped=true&"
import script from "./ERegistrationPublicTermCondView.vue?vue&type=script&lang=js&"
export * from "./ERegistrationPublicTermCondView.vue?vue&type=script&lang=js&"
import style0 from "./ERegistrationPublicTermCondView.vue?vue&type=style&index=0&id=57ba74f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ba74f2",
  null
  
)

/* custom blocks */
import block0 from "@/locales/actions.locale.json?vue&type=custom&index=0&blockType=i18n&issuerPath=E%3A%5Capp%5CJenkins%5Cworkspace%5CAll_IaaS_Farm%5C0%20nextoreV3bdclient_build%5Csrc%5Csrc%5Cpublic%5Cmodules%5Ce-registration%5Cviews%5CERegistrationPublicTermCondView.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports